import { useSelector } from "react-redux";
import { getLanguageCode } from "../store/components";
import * as theme from "../theme";
import _ from "lodash";
import { useState } from "react";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { ImportanceIcon, ImportanceIconShowDecider } from "./QuestionText";
import { getBrokerInformation } from "../store/broker";
const SingleSelectPlatinum = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: theme.SCALES.simpleQuestionsHeight,
      }}
    >
      <QuestionTextOnTop text={text} node={node}></QuestionTextOnTop>
      <div style={{ height: "3vh" }}></div>
      <PlatinumOptions
        handleAnswerChange={handleAnswerChange}
        node={node}
        qfusermode={qfusermode}
      ></PlatinumOptions>
    </div>
  );
};

const QuestionTextOnTop = ({ text, node }) => {
  return (
    <div
      style={{
        width: "100%",
        fontFamily: "GibsonRegular",
        color: theme.COLORS.single_select_platinum_text,
        paddingLeft: "3%",
        fontSize: "1.9vmin",
      }}
    >
      {" "}
      {text + " "}{" "}
      <ImportanceIconShowDecider node={node}></ImportanceIconShowDecider>
    </div>
  );
};

export const PlatinumOptions = ({
  handleAnswerChange,
  node,
  nodescription,
  qfusermode,
}) => {
  const { answer } = node;
  const { options } = node.logic;
  const languagecode = useSelector(getLanguageCode);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const isThisOptionAnswer = (option) => {
    return _.isEqual(answer, option);
  };
  //console.log("show me my options", options);

  return (
    <div>
      {options.map((option, option_idx) => (
        <div
          question-id={`${node.id}`}
          question-answer-idx={`${option_idx}`}
          style={{
            width: "100%",
            minHeight: nodescription
              ? theme.SCALES.minHeightForOptionsInSingleSelect
              : "7vh",
            marginBottom: "1vh",
            // padding: "1vh",
          }}
          key={option.text[languagepreference]}
          onClick={() => {
            if (qfusermode !== INSURER) handleAnswerChange(option);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              if (qfusermode !== INSURER) handleAnswerChange(option);
            }
          }}
        >
          <EachPlatinumOptions
            text={option.text[languagepreference]}
            description={
              option.description ? option.description[languagepreference] : ""
            }
            isSelected={isThisOptionAnswer(option)}
            nodescription={nodescription}
          ></EachPlatinumOptions>
        </div>
      ))}
    </div>
  );
};

const EachPlatinumOptions = ({
  isSelected,
  text,
  description,
  nodescription,
}) => {
  const leftDivWidth = nodescription ? "100%" : "40%";
  const rightDivWidth = `calc(100% - ${leftDivWidth})`;
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        borderRadius: theme.SCALES.groupTabBorderRadius,
        cursor: "pointer",
      }}
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={() => {
        setHover(false);
      }}
    >
      <div
        style={{
          width: nodescription ? theme.inputStyle.width : leftDivWidth,
          height: "80%",
          paddingRight: nodescription ? 0 : "3%",
          paddingLeft: nodescription ? 0 : "3%",
        }}
      >
        <div
          style={{
            width: "100%",
            minHeight: nodescription
              ? theme.SCALES.minHeightForOptionsInSingleSelect
              : "6vmin",
            borderRadius: theme.SCALES.groupTabBorderRadius,
            backgroundColor: isSelected
              ? theme.COLORS.secondary_orange
              : hover
              ? theme.COLORS.little_darker_lightindigo
              : theme.COLORS.tertiary_ligthindigo,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color:
              hover || isSelected
                ? "white"
                : theme.COLORS.platinum_option_main_font,
            // fontWeight: "bold",
            letterSpacing: 1,
            padding: "3%",
            fontSize: "1.7vmin",
          }}
          tabIndex={0}
          onFocus={() => {
            setHover(true);
          }}
          onBlur={() => {
            setHover(false);
          }}
        >
          {text}
        </div>
      </div>
      <div
        style={{
          width: rightDivWidth,
          fontFamily: "GibsonLight",
          fontWeight: "bold",
          fontSize: "1.7vmin",
          color:
            hover || isSelected
              ? theme.COLORS.group_tab_header_completed
              : theme.COLORS.group_tab_header_incomplete,
        }}
      >
        {description}
      </div>
    </div>
  );
};

export default SingleSelectPlatinum;
